export enum ChartErrorCode {
  NotFound = 'CHART_NOT_FOUND',
  // The query breaks the server's rules, e.g. a grouped field deleted since
  QueryInvalid = 'CHART_QUERY_INVALID',
  // The chart's saved register filter was deleted or made personal
  FilterNotFound = 'CHART_FILTER_NOT_FOUND',
  // A save whose config the shared schema refuses
  ConfigInvalid = 'CHART_CONFIG_INVALID',
  // filterDelete of a filter that charts count by
  FilterUsedByCharts = 'FILTER_USED_BY_CHARTS'
}

export const CHART_ERROR_MESSAGES: Record<ChartErrorCode, string> = {
  [ChartErrorCode.NotFound]: 'This chart no longer exists.',
  [ChartErrorCode.QueryInvalid]: 'A field used by this chart was deleted or changed.',
  [ChartErrorCode.FilterNotFound]: "This chart's filter was deleted or is no longer shared.",
  [ChartErrorCode.ConfigInvalid]: 'Some display settings are invalid.',
  [ChartErrorCode.FilterUsedByCharts]: "This filter is used by charts and can't be deleted."
}

// Anything else: INTERNAL_SERVER_ERROR (the job failed or timed out), the network
export const CHART_FAILED_MESSAGE = "Couldn't calculate this chart. Try again later."
